@use "../../../../../../src/styles/Colors.scss" as Colors;
@use "../../../../../../src/styles/Constants.scss" as Constants;

.noticeText {
	color: Colors.$col-design-grey10;
	margin-top: Constants.$val-spacing-m;
	margin-bottom: Constants.$val-spacing-s;
}